import { gql } from "@apollo/client";

export const _createStudentOTpSend = gql`
  mutation CreateStudentOTpSend($input: createStudentOTpSendIn) {
    createStudentOTpSend(input: $input) {
      status
    }
  }
`;
export const _createStudentOTpVerify = gql`
  mutation CreateStudentOTpVerify($input: createStudentOTpVerifyIn) {
    createStudentOTpVerify(input: $input) {
      mobileVerifedToken
    }
  }
`;
export const _createStudent = gql`
  mutation CreateStudent($input: UserAccountIn) {
    createStudent(input: $input) {
      accessToken
      userAccount {
        _id
        fname
        lname
        email
        role
        status
        created_at
        updated_at
      }
    }
  }
`;
export const _loginStudent = gql`
  mutation loginStudent($input: UserLogIn) {
    loginStudent(input: $input) {
      accessToken
      userAccount {
        _id
        fname
        lname
        email
        role
        status
        created_at
        updated_at
      }
    }
  }
`;

export const _me = gql`
  query Me {
    me {
      _id
      fname
      lname
      email
      role
      status
      created_at
      updated_at
    }
  }
`;
export const _getStudentMyProfile = gql`
  query MyProfile {
    getStudentMyProfile {
      account {
        _id
        fname
        lname
        email
        status
        role
        created_at
        updated_at
      }
      profile {
        _id
        account_id
        first_name
        last_name
        school_name
        subject_stream
        subjects
        exm_year
        district
        address
        nfc_institute
        barcode
        nic_no
        selfy_photo
        selfy_photo_new
        nfc_front_url
        nic_front_url_new
        nic_back_url
        nic_back_url_new
        nic_status
        avatar_url
        avatar_url_new
        email
        mobile
        prnt_mobile
        alt_mobile
        status
        created_at
        updated_at
        deleted_at
      }
    }
  }
`;

export const _updateStudentProfile = gql`
  mutation UpdateStudentProfile($input: StudentProfileIn) {
    updateStudentProfile(input: $input) {
      _id
      update_status
      updated_at
    }
  }
`;

export const _forgetPasswordOtpSend = gql`
  mutation ChangePasswordReq($input: changePasswordReqIn) {
    changePasswordReq(input: $input) {
      status
    }
  }
`;
export const _forgetPassword = gql`
  mutation ChangePassword($input: changePasswordIn) {
    changePassword(input: $input) {
      status
    }
  }
`;
export const _changePassword = gql`
  mutation ChangePasswordByPvs($input: changePasswordByPvsIn) {
    changePasswordByPvs(input: $input) {
      status
    }
  }
`;

export const _paymentHistory = gql`
  query SearchPeymentRecipts($input: PaymentReciptSearchIn) {
    searchPeymentRecipts(input: $input) {
      limit
      skip
      resultCount
      result {
        _id
        final_amount
        created_at
        payment_recipt_status
        subject
        course_name
      }
    }
  }
`;
export const _paymentReceipt = gql`
  query GetPeymentRecipt($itemId: String) {
    getPeymentRecipt(itemId: $itemId) {
      recipt {
        _id
        amount
        created_at
        discount
        final_amount
        payment_recipt_status
        student_name
      }
      payment_items {
        payment_recipt_id
        amount
        cources_id
        created_at
        year
        month
        subject
        course_name
      }
    }
  }
`;
